import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { Urls } from '../../../../utils/catalogue/urls';
import { ApiService } from '../../../../shared/catalogue/services/api.service';
import { CommonDataService } from '../../../../shared/catalogue/services/common-data.service';
import { DATA_PER_PAGE, CANCEL, File_deleted } from './../../../../app.constant';

const MAX_FILE_SIZE = 1000000;

@Component({
  selector: 'app-forms-updates',
  templateUrl: './forms-updates.component.html',
  styleUrls: ['./forms-updates.component.scss'],
})
export class FormsUpdatesComponent implements OnChanges {
  @Input() data: any[];

  pageSize: number = DATA_PER_PAGE;

  updatePDFsData: any[] = [];

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.data) {
      this.filterPdf(this.data);
    }
  }

  getDocs = () => {
    this.apiService.getData(Urls.getSectionDocs).subscribe((response: any) => {
      this.filterPdf(response.data.list);
    });
  };

  public filterPdf(data: any[]) {
    const updatePDFsData = data.filter((pdf) => {
      return pdf.type === 'Updates' || pdf.type === '1';
    });

    this.updatePDFsData = [...updatePDFsData];
  }

  viewFile = (path) => {
    window.open(path, '_blank');
  };

  deleteData = (id) => {
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteSectionDocuments, { id })
            .subscribe((response: any) => {
              this.toastr.success(File_deleted);
              this.getDocs();
            });
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  };
}
